import { autoCapitalize } from '@/utils/autoCapitalize'
import { formatCPF } from '@/utils/formatCPF/formatCPF'
import { phoneReplace } from '@/utils/formatPhone'
import { PatientData } from './LinkedPsychologists.types'

class PatientDataMapper {
  toDomain(persistenceData): PatientData {
    return {
      patientId: persistenceData?.idPaciente,
      userId: persistenceData?.idUsuario,
      clinicId: persistenceData?.idClinica,
      patientName: autoCapitalize(persistenceData?.nome),
      birthday: persistenceData?.dataNascimento,
      cpf: formatCPF(persistenceData?.cpf),
      email: persistenceData?.email,
      phone: phoneReplace(persistenceData?.telefoneCel),
      clinicName: autoCapitalize(persistenceData?.nomeClinica),
      ownership: persistenceData?.titularidade,
      patientStatus: persistenceData?.statusPaciente,
      userStatus: persistenceData?.statusUsuario,
      screening: persistenceData?.triagemRealizada ? 'Sim' : 'Não',
    }
  }
}

export default new PatientDataMapper()
